require('./style.mn');
import './index.scss';

const React = require('react');
const App = require('./App');

document.body.className = require('mn-utils/browser/detectionByWindow')(window);
require('react-dom').render(<App/>, document.getElementById('root'));


// debug API
if (process.env.MOCK || process.env.TESTING || process.env.RC) {
  window.LunuConsoleDebug = {
    ...require('./api/_auth'),
    ...require('./api/admin/accounts'),
    ...require('./api/admin/accountsKYC'),
    ...require('./api/admin/arbitrageDeposits'),
    ...require('./api/admin/auctions'),
    ...require('./api/admin/depositsStatus'),
    ...require('./api/admin/earnedMoney'),
    ...require('./api/admin/exchangeOrders'),
    ...require('./api/admin/exchangeRates'),
    ...require('./api/admin/failedAuctions'),
    ...require('./api/admin/mailSystem'),
    ...require('./api/admin/maintenance'),
    ...require('./api/admin/merchantStatistic'),
    ...require('./api/admin/oracles'),
    ...require('./api/admin/orderedTerminals'),
    ...require('./api/admin/status'),
    ...require('./api/admin/terminals'),
    ...require('./api/admin/transactionCollision'),
    ...require('./api/admin/transactions'),
    ...require('./api/admin/withdraws'),
    ...require('./api/admin/payout'),

    ...require('./api/merchant/cash'),
    ...require('./api/merchant/help'),
    ...require('./api/merchant/ibans'),
    ...require('./api/merchant/promo'),
    ...require('./api/merchant/salesNotification'),
    ...require('./api/merchant/settings'),
    ...require('./api/merchant/terminals'),
    ...require('./api/merchant/transactions'),
    ...require('./api/merchant/app'),

    ...require('./api/merchant/kyc'),
  };
}
